import { TFunction } from 'i18next';
import { Link } from 'react-router-dom';

import { Badge, Button, Text, UserInfoCard } from '@pentabd/ui';

import { capitalizeFirstLetter } from '@utils/capitalize';
import { useLanguage } from '@hooks/useLanguage';
import { IconUpload01, IconUpload02, IconUploadCloud01 } from '@pentabd/icons';

export const CreateProductBatchTableColumn = (
  t: TFunction<'translation', undefined>,
  data: any,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: 'name',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.NAME'),
      render: (_: number, row: any) => {
        // const name = language === 'bn' ? row.nameBn : row.name;
        const name = row.name;
        const designation = 'designation';
        return <UserInfoCard title={name} subtitle={''} />;
      },
    },
    {
      id: 2,
      key: 'category',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.CATEGORY'),
      render: (category: string, row: any) => {
        return <Text color="subtitle1">{category}</Text>;
      },
    },
    {
      id: 3,
      key: 'group',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.GROUP'),
      render: (group: string) => <Text color="subtitle1">{group}</Text>,
    },
    {
      id: 4,
      key: 'type',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.TYPE'),
      render: (type: string) => <Text color="subtitle1">{type}</Text>,
    },

    {
      id: 5,
      key: 'unit',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.UNIT'),
      render: (unit: string) => <Text color="subtitle1">{unit}</Text>,
    },
    {
      id: 6,
      key: 'unitPrice',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.UNIT_PRICE'),
      render: (unitPrice: string) => <Text color="subtitle1">{unitPrice}</Text>,
    },
    {
      id: 7,
      key: 'price',
      // name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.PRICE'),
      name: 'Amount',
      render: (price: string) => <Text color="subtitle1">{price}</Text>,
    },
    {
      id: 8,
      key: 'warrantyStartDate',
      name: t(
        'INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.WARRANTY_START_&_END',
      ),
      render: (warrantyStartDate: string, row: any) => (
        <>
          <Text color="subtitle1" component="p">
            {row?.warrantyEndDate}
          </Text>
          <Text color="subtitle1" component="p">
            {row?.warrantyEndDate}
          </Text>
        </>
      ),
    },
    {
      id: 9,
      key: 'document',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.DOCUMENT'),
      render: (document: any) => (
        <Button fill="outline" type="dark" size="xs">
          <IconUploadCloud01 fill="dark" size="17" />
          {t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.UPLOAD_BUTTON')}
        </Button>
      ),
    },

    {
      id: 10,
      key: 'lotNo',
      name: t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.COLUMN.LOT_NO'),
      render: (lotNo: string) => <Text color="subtitle1">{lotNo}</Text>,
    },

    {
      id: 11,
      key: 'status',
      render: (status: any, row: any) => {
        return (
          <div className="d-flex justify-content-end">
            <Button
              fill="outline"
              type="primary"
              size="xs"
              className="me-5"
              // onClick={onAddTagOpen}
            >
              {t('INVENTORY_CREATE_PRODUCT_BATCH.TABLE.REMOVE_BUTTON')}
            </Button>
          </div>
        );
      },
    },
  ];
};
